import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import "./datepicker-overrides.css";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-toggle="datepicker"]').forEach(function (el) {
    flatpickr(el, {
      minDate: "today",
      dateFormat: "m/d/Y",
      position: "below",
      disableYearArrows: true,
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        },
      },
    });
  });
});
